<script setup lang="ts">
import { computed } from 'vue'
import type { AppLocale } from '@/i18n/messages'
import { streamMessages } from '@/i18n/stream'
import type { SceneSkin } from '@/ui/pip-skins'
import type { StreamHudData } from '@/ui/stream-hud'

const props = defineProps<{ skin: SceneSkin; data: StreamHudData; locale: AppLocale }>()
const copy = computed(() => streamMessages[props.locale])
const ratio = computed(() => Number.isFinite(props.data.expRatio) ? Math.max(0, Math.min(1, props.data.expRatio)) : 0)
</script>

<template>
  <div class="scene-progress sh-progress-group" :data-progress-skin="skin" data-tier="1" data-stream-measure>
    <svg v-if="skin === 'stream-kerning'" class="kerning-route" viewBox="0 0 240 22" preserveAspectRatio="none" :aria-label="`EXP ${data.expPercent}`" role="img">
      <path class="kerning-route-base" d="M6 16H68L84 6H158L176 16H234" />
      <path class="kerning-route-fill" d="M6 16H68L84 6H158L176 16H234" pathLength="100" stroke-dasharray="100" :stroke-dashoffset="100 * (1 - ratio)" />
      <g class="kerning-route-stops"><circle cx="6" cy="16" r="3" /><circle cx="84" cy="6" r="3" /><circle cx="158" cy="6" r="3" /><circle cx="234" cy="16" r="3" /></g>
    </svg>
    <div v-else class="scene-progress-track" :aria-label="`EXP ${data.expPercent}`"><i :style="{ transform: `scaleX(${ratio})` }" /></div>
    <div class="sh-progress-copy" data-stream-measure><strong data-stream-measure>{{ data.expPercent }}</strong><span data-stream-measure>{{ copy.eta }} <b>{{ data.eta }}</b></span></div>
  </div>
</template>
